export default "__VITE_ASSET__wSCBvnBX__"